import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  Components,
  customHooks,
  ThisGorillaUtils,
} from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import styled from "styled-components";
import { API_CALLS } from "../../../../../../API/api_calls";
import { API_PATHS } from "../../../../../../API/api_paths";
import { FlexRowCenter, LoadingContainer } from "../../../../../Common/Styles";
import ImageProps from "../Image";

const ImageItem = ({
  id,
  order_id,
  onlyForLoader = false,
}: ImageProps.ImageItem) => {
  const ref = useRef<HTMLDivElement>(null);
  const { isHovered } = customHooks.useMouseOver({ ref });
  const [isImageLoading, setIsImageLoading] = useState(true);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={{ ...style, position: "relative" }}>
      <ImageContainer {...listeners} {...attributes} ref={ref}>
        {!onlyForLoader && (
          <Image
            src={API_PATHS.posts.getPostImage + id}
            onLoad={() => setIsImageLoading(false)}
          />
        )}
      </ImageContainer>

      {isImageLoading ? (
        <LoadingContainer $loadingCount={4}>
          <Components.Loading size="small" />
        </LoadingContainer>
      ) : (
        <>
          {isHovered && (
            <MoveButton>
              <Components.IconButton
                disabled={false}
                iconType="Crop"
                kind="Tertiary"
                onClick={() => {}}
                size="XXS"
                IconButtonColor="#E5E8EB"
              />
            </MoveButton>
          )}
          <DeleteButton>
            <Components.IconButton
              disabled={false}
              iconType="X"
              kind="Opacity"
              onClick={() => {
                API_CALLS.ARTICLE.deleteAnArticleImage(id, order_id);
              }}
              size="XXS"
            />
          </DeleteButton>
        </>
      )}
    </div>
  );
};

export default ImageItem;

const ImageContainer = styled.div`
  cursor: pointer;
  width: ${ThisGorillaUtils.convertPxToRem("70")}rem;
  height: ${ThisGorillaUtils.convertPxToRem("70")}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
const DeleteButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 1;
  & > button {
    box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  }
`;
const MoveButton = styled(FlexRowCenter)`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.neutral.subtle.hover.value};
`;

const Image = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 1;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  object-fit: cover;
`;
